module.exports = __webpack_public_path__ + "img/student_female.0e60ecd9.png";